import * as React from "react"
import '../scss/separator.scss'
const Separator = ({className}: {className?: string}) => {
    return <div
        className={"Separator primary-border-color " + className}
    >
    </div>
}

export default Separator